import { SET_NEWS } from "../../constants/newsConstants";

export const setNews = (news) => {
  return{
    type: SET_NEWS,
    news
  };
};